<script setup lang="ts">
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'
import store from '@/store'
import { EAuthActions } from '@/store/authStore/AuthStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { ref } from 'vue'
import FullScreenLoader from '../../LoadingSpinner/FullScreenLoader.vue'

type Props = {
    email: string
}
const props = defineProps<Props>()
const isLoading = ref(false)

const resetPassword = () => {
    isLoading.value = true
    store
        .dispatch(`${EStoreModules.AUTHENTICATION}/${EAuthActions.FORGOT_PASSWORD}`, props.email)
        .finally(() => (isLoading.value = false))
}
</script>

<template>
    <FullScreenLoader :isLoading="isLoading" />
    <PrimaryButton
        :label="$t('user.buttons.resetPassword')"
        @click="resetPassword"
        class="reset-password-button" />
</template>

<style scoped lang="scss">
.reset-password-button {
    height: auto;
    & :deep(span) {
        white-space: normal;
    }
}
</style>
